var map = {
	"./DarkBlue0000.png": 1132,
	"./DarkBlue0001.png": 1133,
	"./DarkBlue0002.png": 1134,
	"./DarkBlue0003.png": 1135,
	"./DarkBlue0004.png": 1136,
	"./DarkBlue0005.png": 1137,
	"./DarkBlue0006.png": 1138,
	"./DarkBlue0007.png": 1139,
	"./Green0000.png": 1140,
	"./Green0001.png": 1141,
	"./Green0002.png": 1142,
	"./Green0003.png": 1143,
	"./Green0004.png": 1144,
	"./Green0005.png": 1145,
	"./Green0006.png": 1146,
	"./Green0007.png": 1147,
	"./LightBlue0000.png": 1148,
	"./LightBlue0001.png": 1149,
	"./LightBlue0002.png": 1150,
	"./LightBlue0003.png": 1151,
	"./LightBlue0004.png": 1152,
	"./LightBlue0005.png": 1153,
	"./LightBlue0006.png": 1154,
	"./LightBlue0007.png": 1155,
	"./Red0000.png": 1156,
	"./Red0001.png": 1157,
	"./Red0002.png": 1158,
	"./Red0003.png": 1159,
	"./Red0004.png": 1160,
	"./Red0005.png": 1161,
	"./Red0006.png": 1162,
	"./Red0007.png": 1163,
	"./White0000.png": 1164,
	"./White0001.png": 1165,
	"./White0002.png": 1166,
	"./White0003.png": 1167,
	"./White0004.png": 1168,
	"./White0005.png": 1169,
	"./White0006.png": 1170,
	"./White0007.png": 1171,
	"./Yellow0000.png": 1172,
	"./Yellow0001.png": 1173,
	"./Yellow0002.png": 1174,
	"./Yellow0003.png": 1175,
	"./Yellow0004.png": 1176,
	"./Yellow0005.png": 1177,
	"./Yellow0006.png": 1178,
	"./Yellow0007.png": 1179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1131;